// Utility for managing authentication method preferences and "last used" tracking
const LAST_AUTH_METHOD_KEY = 'last_auth_method'

export type AuthMethod = 'email' | 'google'

/**
 * Get the last used authentication method
 */
export const getLastAuthMethod = (): AuthMethod | null => {
  if (typeof window === 'undefined') return null
  
  try {
    const method = localStorage.getItem(LAST_AUTH_METHOD_KEY)
    return method as AuthMethod | null
  } catch {
    return null
  }
}

/**
 * Set the last used authentication method
 */
export const setLastAuthMethod = (method: AuthMethod): void => {
  if (typeof window === 'undefined') return
  
  try {
    localStorage.setItem(LAST_AUTH_METHOD_KEY, method)
  } catch {
    // Silently fail if localStorage is not available
  }
}

/**
 * Clear the last used authentication method
 */
export const clearLastAuthMethod = (): void => {
  if (typeof window === 'undefined') return
  
  try {
    localStorage.removeItem(LAST_AUTH_METHOD_KEY)
  } catch {
    // Silently fail if localStorage is not available
  }
}